import React from 'react';
import Carousel from "react-bootstrap/Carousel";


function CarouselComponent() {
  const slides = [
    {
      img: "/Images/carousel-pic1.jpg",
      text: (
        <>
        On<span className='text-color'>Point</span> Services
        </>
      )
    },
    {
      img: "/Images/carousel-pic2.jpg",
      text: (
      <>
        We provide reliable and efficient
        <br/>
          all rounded maintenance services.
      </>
    )
    },
    {
      img: "/Images/carousel-pic3.webp",
      text: (
      <>
        24/7 expert support for homes and businesses,
        <br/>
        with safety and satisfaction guaranteed.
      </>
    )
    }
  ];

  return (
    <Carousel>
      {slides.map((slide, index) => (
        <Carousel.Item key={index}>
          <div className="carousel-image-container">
            <img
              src={slide.img}
              alt={`Slide ${index + 1}`}
              className="carousel-image"
            />
            <div className="carousel-overlay-text">{slide.text}</div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default CarouselComponent;
